import DetailPageContent from './components/detailPageContent';
import NavigationHeader from './components/navigationHeader';
import PageContainer from './components/pageContainer';
import PageFooter from './components/pageFooter';
import PageLayout from './components/pageLayout';
import PageBody from './components/pageBody';
import PageText from './components/pageText';

export const HomePage = () => {
    return (
        <>
            <PageLayout>
                <PageContainer>
                    <PageBody>
                    <NavigationHeader></NavigationHeader>
                    <PageText>
                        <div className='homePageContent'>
                            <img src={require('../images/winter.JPG')} ></img>
                            <img src={require('../images/winter1.JPG')} ></img>
                            <img src={require('../images/pinkGirls.JPG')} ></img>
                        </div>
                    </PageText>
                    <PageFooter />
                </PageBody>
                </PageContainer>
            </PageLayout>
        </>
    )
}